<template>
<a name="Comments-next">
  <!-- <lazy-component @show.once="render(false)"> -->
    <div class="wrapper" v-if="commentList.length > 0">
      <div class="comTipBack" v-if="tipnewlist.list.length > 0">
        <span class="com-tip-buttonall" @click="clickALL">全部</span>
        <span class="com-tip-button"
              v-for="(item, index) in tipnewlist.list"
              :key="index"
              @click="clickTip(item)">{{item.name}}</span>
      </div>
      <div :style="{paddingLeft: '30rpx'}">
        <div class="comment"
            v-for="(item, index) in commentList"
            @click="clickCommentItem(item)"
            :key="index">
          <div class="image-wrapper"
          v-if="item.PostUserInfo">
            <img class="header-img" :src="`https://avator.eastmoney.com/qface/${item.PostUserInfo?item.PostUserInfo.PassportId:''}/120`" />
            <img :src="isUserV(item.PostUserInfo.UserV)"
            v-if="isUserV(item.PostUserInfo.UserV).length > 0" class="userV" />
          </div>
          <div class="image-wrapper"
            v-else >
            <img class="header-img" :src="'https://avator.eastmoney.com/qface/120'" />
          </div>
          <div class="comment-content">
            <div class="name-view">
              <span class="user-name" v-if="item.PostUserInfo">{{item.PostUserInfo.NiCheng}}</span>
              <span class="user-name" v-else>--</span>
              <span class="hold-tag"
                v-if="getholdtip(item) && getholdtip(item).length > 0"
                :class="getaddholdclass(item)" @click.stop="holdTip(item)"
                >{{getholdtip(item)}}</span>
            </div>
            <div class="comment-text">
              <span
                v-if="item.TitleIsShow>=0 && item.PostTitle"
                class="post-title"
              >{{item.PostTitle}}</span>
              <Content
                :tip="' '"
                :content="item['Summary']"
                :keyWords="item['ContentKeyWords']">
              </Content>
              <img
                  class="comment-image"
                  :style="`height:${titleitem.PicRatio>0?100/titleitem.PicRatio:100}px`"
                  :src="titleitem.s500"
                  v-for="(titleitem, index) in item.Pic"
                  :key="index"
                  @click.stop="showGallery(titleitem, index)"
                />
            </div>
            <div class="comment-v">

              <span class="comment-time">{{barGetDateFormat(item.PublishTime)}}</span>
              <div class="comment-option">
                <img
                  class="option-icon"
                  :src="getlikeImage(item)"
                />
                <img
                  class="option-icon"
                  src="@/assets/ef_fundbar_post_cell_comment.png"
                />
              </div>
            </div>
            <Detailreply
              :userData="item"
              :replys="item.Comments"
              :totalNum="item.PostCommentCount"
              :likeCount="item.PostLikeCount"
              v-if="checkshowComments(item.Comments, item.PostLikeCount, item.like)"
            >
            </Detailreply>
          </div>
        </div>
      </div>
      <ModuleButton
      :click="clickMore"
      value="至APP查看更多讨论" v-if="commentList.length > 1"/>
      <Gallery ref="gallery" :album="album" :position="position" :PicRatio="PicRatio" ></Gallery>
    </div>
    <div class="empwrapper" v-else @click="clickReload">
     <p class="emptext" v-if="!loadError">暂无讨论信息</p>
     <p class="emptext" v-else>网络不给力，请点击重试</p>
    </div>
  <!-- </lazy-component> -->
</a>
</template>

<script>

import likeNomal from '@/assets/ef_fundbar_post_like_nomal.png';
import likeSelect from '@/assets/ef_fundbar_post_like_select.png';
import Util from '@/base/Util';
import Content from '@/components/Fund-bar-content.vue';
import Detailreply from '@/components/Fund-bar-reply.vue';
import ModuleButton from '@/components/ModuleButton.vue';
import Gallery from '@/components/prefix-gallery.vue';
import organizationimg from '@/static/images/fundbar_post_vip_organization_large.png';
import personalimg from '@/static/images/fundbar_post_vip_personal_large.png';
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
// import { mapGetters } from 'vuex';
import {
  detailPushPage,
  getBarInteract,
  setBarInteract,
  showCommentView,
  userLogin,
} from '@/utils/nativeBridge';
import Vue from 'vue';

export default {
  name: 'FundComments',
  components: {
    ModuleButton,
    Content,
    Detailreply,
    Gallery,
  },
  props: {
    fundCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // fundCode: '',
      getDateFormat: '',
      album: [
        // 'http://gbres.dfcfw.com/Files/picture/20200713/size500//934FC9F9E5632B0C4B472DC8F57686AE_w1019h2208.jpg',
        // 'http://gbres.dfcfw.com/Files/picture/20200713/size500//E8A3EBD9E476EEA700D4474843AFA04D_w1242h1400.jpg',
      ],
      position: 0,
      commentList: [

      ],
      PicRatio: 0.5,
      tiplist: [],
      mTitle: '讨论',
      userDate: {},
      loadError: false,
      bartipinfo: {}, // 基金吧数据
    };
  },
  mounted() {
    this.render();
  },
  computed: {
    // ...mapGetters({
    //   bartipinfo: 'currentConfigureQuestion',
    // }),
    tipnewlist() {
      const list = [];
      if (!this.bartipinfo) {
        return {
          list: [],
          title: '讨论',
        };
      }
      // if (!this.$store.state.question.fund[this.fundCode]) {
      //   return [];
      // }
      const pCount = this.bartipinfo.PostCount;
      let mTitle = '';
      if (!isEmpty(pCount)) {
        if (pCount !== '0') {
          mTitle = `讨论（${pCount}）`;
        }
      }
      const tipData = this.bartipinfo.VarietyDynamicStatistics;
      if (tipData) {
        const { ProfitUserPostCount, ElitePostCount, FundManagerPostCount } = tipData;
        if (ProfitUserPostCount && ProfitUserPostCount > 0) {
          // 悬赏中
          list.push({
            name: `持有人帖 ${this.getWanCount(ProfitUserPostCount)}`,
            eventname: 'pz.tl.cyr.click',
            link: {
              LinkType: '1',
              LinkTo: `fund://mp.1234567.com.cn/weex/48242f55e8704a59a9344e9582cc9724/pages/singleBar/singleBarHomePage?fundCode=${this.fundCode}&currentIndex=1`,
            },
          });
        }
        if (ElitePostCount && ElitePostCount > 0) {
          // 悬赏中
          list.push({
            name: `精华帖 ${this.getWanCount(ElitePostCount)}`,
            eventname: 'pz.tl.jht.click',
            link: {
              LinkType: '1',
              LinkTo: `fund://mp.1234567.com.cn/weex/48242f55e8704a59a9344e9582cc9724/pages/singleBar/singleBarHomePage?fundCode=${this.fundCode}&currentIndex=2`,
            },
          });
        }
        if (FundManagerPostCount && FundManagerPostCount > 0) {
          // 悬赏中
          list.push({
            name: `基金经理帖  ${this.getWanCount(FundManagerPostCount)}`,
            eventname: 'pz.tl.jjjl.click',
            link: {
              LinkType: '1',
              LinkTo: `fund://mp.1234567.com.cn/weex/48242f55e8704a59a9344e9582cc9724/pages/singleBar/singleBarHomePage?fundCode=${this.fundCode}&currentIndex=3`,
            },
          });
        }
      }
      return {
        list,
        title: mTitle,
      };
    },
  },
  created() {
    // this.configureFund();
    this.getDateFormat = Util.getDateFormat('2020-03-30');
    this.handleDefault();
  },
  methods: {
    clickCommentItem(item) {
      // 跳转
      // eslint-disable-next-line no-undef
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wxmp') {
        const postId = item.Type === 1 ? item.NewsId : item.PostId;
        // eslint-disable-next-line no-undef
        wx.miniProgram.navigateTo({
          // eslint-disable-next-line no-undef
          url: `/pages/news/newsDetail?code=${postId}&type=${item.Type === 1 ? 100 : 200}`,
        });
      } else {
        this.$goFundApp();
      }
    },
    showGallery(item, index) {
      // const [, src] = e.target.dataset.img.match(/"(.*)"/);
      // const imgArr = [].concat(src.trim());
      // #if EXECUTION_ENV === 'fund'
      // eslint-disable-next-line no-undef
      if (fund && fund.previewImage) {
        // eslint-disable-next-line
        fund.previewImage({
          index,
          images: [
            {
              url: item.s500,
            },
          ],
        });
        return;
      }
      // #endif
      console.log(index);
      this.position = 0;
      this.PicRatio = parseFloat(item.PicRatio);
      this.album = [item.s500];
      this.$refs.gallery.showGallery();
    },
    checkshowComments(Comments, PostLikeCount, like) {
      if (!isEmpty(Comments)) {
        return true;
      }
      if (PostLikeCount > 0) {
        return true;
      }
      if (like) {
        return true;
      }
      return false;
    },
    render(iscache) {
      // this.configureFund();
      this.request(iscache);
    },
    configureFund() {
      this.fundCode = this.$store.state.native.fund.fundCode;
    },
    clickReload() {
      this.loadError = false;
      this.render(false);
    },
    async request(iscache) {
      if (!iscache) {
        await this.$store.dispatch('updateFundBarList', this.fundCode).catch((e) => {
          console.log(e);
        });
      }
      const fundIdAll = this.$store.state.quotation.fund[
        `${this.fundCode}FundBarList`
      ];
      if (!fundIdAll) {
        this.loadError = true;
        return;
      }
      const fundId = fundIdAll.Data;
      if (!fundId) {
        if (!fundIdAll) {
          this.loadError = true;
        }
        if (!fundIdAll.Success) {
          this.loadError = true;
        }
        return;
      }
      // #if EXECUTION_ENV === 'fund'
      if (fundId && fundId.length > 0) {
        for (let index = 0; index < fundId.length; index += 1) {
          const element = fundId[index];
          getBarInteract({
            type: 2,
            id: element.PostId,
          }).then((item) => {
            if (item.state) {
              Vue.set(element, 'like', true);
            } else {
              Vue.set(element, 'like', false);
            }
          }).catch(() => {

          });
        }
      }
      // #endif
      this.commentList = fundId;
      if (this.commentList.length > 0) {
        const item = this.commentList[0];
        if (item.PostId) {
          // this.$store.dispatch('updateBarFistCacheData',
          // { key: this.fundCode, value: item.PostId });
        }
      }
      this.$store.dispatch('updateQuestion', this.fundCode).then((res) => {
        this.bartipinfo = res;
        this.configureTiplist();
      }).catch((e) => {
        console.log(e);
      });
      this.configureTiplist();
    },
    configureBarinfo(item) {
      const list = [];
      if (!item) {
        return [];
      }
      // if (!this.$store.state.question.fund[this.fundCode]) {
      //   return [];
      // }
      const pCount = item.PostCount;
      if (pCount && pCount.length > 0) {
        if (pCount !== '0') {
          this.mTitle = `讨论（${pCount}）`;
        }
      }
      const tipData = item.VarietyDynamicStatistics;
      if (tipData) {
        const { ProfitUserPostCount, ElitePostCount, FundManagerPostCount } = tipData;
        if (ProfitUserPostCount && ProfitUserPostCount > 0) {
          // 悬赏中
          list.push({
            name: `持有人帖 ${this.getWanCount(ProfitUserPostCount)}`,
            eventname: 'pz.tl.cyr.click',
            link: {
              LinkType: '1',
              LinkTo: `fund://page/fbproduct?fundcode=${this.fundCode}`,
            },
          });
        }
        if (ElitePostCount && ElitePostCount > 0) {
          // 悬赏中
          list.push({
            name: `精华帖 ${this.getWanCount(ElitePostCount)}`,
            eventname: 'pz.tl.jht.click',
            link: {
              LinkType: '1',
              LinkTo: `fund://page/fbproduct?fundcode=${this.fundCode}`,
            },
          });
        }
        if (FundManagerPostCount && FundManagerPostCount > 0) {
          // 悬赏中
          list.push({
            name: `基金经理帖  ${this.getWanCount(FundManagerPostCount)}`,
            eventname: 'pz.tl.jjjl.click',
            link: {
              LinkType: '1',
              LinkTo: `fund://page/fbproduct?fundcode=${this.fundCode}`,
            },
          });
        }
      }
      return list;
    },
    getWanCount(count) {
      if (count) {
        if (parseFloat(count) > 10000) {
          //
          return `${parseFloat(parseFloat(count) / 10000).toFixed(1)}万`;
        }
        return count;
      }
      return '';
    },
    configureTiplist() {
      // 配置标签
      const list = [];
      if (!this.$store.state.question.fund[this.fundCode]) {
        return;
      }
      const pCount = this.$store.state.question.fund[this.fundCode].PostCount;
      if (pCount && pCount.length > 0) {
        if (pCount !== '0') {
          this.mTitle = `讨论（${pCount}）`;
        }
      }
      const tipData = this.$store.state.question.fund[this.fundCode].VarietyDynamicStatistics;
      if (tipData) {
        const { ProfitUserPostCount, ElitePostCount, FundManagerPostCount } = tipData;
        if (ProfitUserPostCount && ProfitUserPostCount > 0) {
          // 悬赏中
          list.push({
            name: `持有人帖 ${this.getWanCount(ProfitUserPostCount)}`,
            eventname: 'pz.tl.cyr.click',
            link: {
              LinkType: '1',
              LinkTo: `fund://page/fbproduct?fundcode=${this.fundCode}`,
            },
          });
        }
        if (ElitePostCount && ElitePostCount > 0) {
          // 悬赏中
          list.push({
            name: `精华帖 ${this.getWanCount(ElitePostCount)}`,
            eventname: 'pz.tl.jht.click',
            link: {
              LinkType: '1',
              LinkTo: `fund://page/fbproduct?fundcode=${this.fundCode}`,
            },
          });
        }
        if (FundManagerPostCount && FundManagerPostCount > 0) {
          // 悬赏中
          list.push({
            name: `基金经理帖  ${this.getWanCount(FundManagerPostCount)}`,
            eventname: 'pz.tl.jjjl.click',
            link: {
              LinkType: '1',
              LinkTo: `fund://page/fbproduct?fundcode=${this.fundCode}`,
            },
          });
        }
      }
      this.tiplist = list;
    },
    clickALL() {
      this.reportMonitor({
        eventName: 'pz.tl.qb.click',
        infoCodeType: '5',
        infoCode: this.fundCode,
      });
    },
    clickTip(item) {
      const { LinkType, LinkTo } = item.link;
      detailPushPage({
        type: LinkType,
        url: LinkTo,
      });
      if (item.eventname) {
        this.reportMonitor({
          eventName: item.eventname,
          infoCodeType: '5',
          infoCode: this.fundCode,
        });
      }
    },
    handleDefault() {
      this.handleData();
    },
    handleData() {},
    loadData() {},
    isUserV(userV) {
      let result = '';
      switch (userV) {
        case 0:
          result = '';
          break;
        case 1:
          result = organizationimg;
          break;
        case 2:
          result = personalimg;
          break;
        default:
          result = '';
      }
      return result;
    },
    linkToFundBarDetail(item) {
      const { PostId, Type, TypeAbout } = item;
      // 默认帖子
      let url = `fund://page/fbarticle?postid=${PostId}&scrollcomment=false`;
      if (Type === 49) {
        // 提问
        url = `fund://page/barQuestionDetail?postid=${PostId}&qid=${TypeAbout.QuestionId}`;
      } else if (Type === 50) {
        // 回答
        url = `fund://page/barAnswerDetail?postid=${PostId}&qid=${TypeAbout.QuestionId}&aid=${TypeAbout.AnswerId}`;
      }
      detailPushPage({
        type: 1,
        url,
      });
      this.reportMonitor({
        eventName: 'pz.jjtl.neirong',
        infoCodeType: '5',
        infoCode: this.fundCode,
        postid: PostId,
        eventContent: {
          postid: PostId,
        },
      });
    },
    barGetDateFormat(str) {
      return Util.formatTimeString(str);
    },
    linkToUserHome() {
      // const { PostUserInfo } = item;
      // const { PassportId } = PostUserInfo;
    },
    clickUserName(item) {
      this.clickAvator(item);
    },
    clickAvator(item) {
      const { PassportId } = item.PostUserInfo;
      detailPushPage({
        name: 'avatorClick',
        type: 1,
        url: `fund://page/personalhome?passportid=${PassportId}`,
      });
      this.reportMonitor({
        eventName: 'pz.tl.zz.click',
        infoCodeType: '5',
        infoCode: this.fundCode,
      });
    },
    clickComment() {
      detailPushPage({
        type: 1,
        isVerifyLogin: true,
        url: `fund://page/barPost?login=true&fundCode=${this.fundCode}`,
      });
      this.reportMonitor({
        eventName: 'pz.xx.ft',
        infoCodeType: '5',
        infoCode: this.fundCode,
      });
    },
    getlikeImage(item) {
      if (item.like) {
        return likeSelect;
      }
      return likeNomal;
    },
    eventCancelAddLike(item) {
      if (item.PostId) {
        this.reportMonitor({
          eventName: 'pz.tl.qxdz.click',
          infoCodeType: '5',
          infoCode: this.fundCode,
          postid: item.PostId,
          eventContent: {
            postid: item.PostId,
          },
        });
      }
    },
    async cancelAddLike(item) {
      await this.$store.dispatch('updateCancelLikePost', item.PostId);
      const stateData = this.$store.state.quotation.fund[`${item.PostId}CancelLikePost`];
      if (stateData) {
        if (stateData.Data) {
          // 调用接口成功
          return;
        }
      }
      Vue.set(item, 'like', true);
      setBarInteract({
        type: 2,
        id: item.PostId,
        status: true,
      }).then(() => {
      }).catch(() => {
      });
      this.$feedback.showToast({ title: '取消点赞失败', duration: 3000 });
    },
    async setAddLike(item) {
      await this.$store.dispatch('updateLikePost', item.PostId);
      const stateData = this.$store.state.quotation.fund[`${item.PostId}LikePost`];
      if (stateData) {
        if (stateData.Data) {
          // 调用接口成功
          return;
        }
      }
      Vue.set(item, 'like', false);
      setBarInteract({
        type: 2,
        id: item.PostId,
        status: false,
      }).then(() => {
      }).catch(() => {
      });
      this.$feedback.showToast({ title: '点赞失败', duration: 3000 });
    },
    addLike(item) {
      // #if EXECUTION_ENV == 'web'
      // eslint-disable-next-line no-undef
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wxmp' || webPlatf === 'wap' || webPlatf === 'quick' || webPlatf === 'wx') {
        detailPushPage({
          type: 1,
          url: `fund://page/fbproduct?fundcode=${this.fundCode}`,
        });
        return;
      }
      // #endif
      userLogin().then(() => {
        if (item.like) {
          Vue.set(item, 'like', false);
          setBarInteract({
            type: 2,
            id: item.PostId,
            status: false,
          });
          this.cancelAddLike(item);
        } else {
          Vue.set(item, 'like', true);
          setBarInteract({
            type: 2,
            id: item.PostId,
            status: true,
          }).then(() => {
          }).catch(() => {
          });
          this.setAddLike(item);
        }
      }).catch(() => {

      });
      if (!item.like) {
        this.reportMonitor({
          eventName: 'pz.jjtl.lz.dzan',
          infoCodeType: '5',
          infoCode: this.fundCode,
          postid: item.PostId,
          eventContent: {
            postid: item.PostId,
          },
        });
      } else {
        this.eventCancelAddLike(item);
      }
    },
    commentPost(item) {
      // #if EXECUTION_ENV == 'web'
      // eslint-disable-next-line no-undef
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wxmp' || webPlatf === 'wap' || webPlatf === 'quick' || webPlatf === 'wx') {
        console.log(`jasdha;lksjdf;${webPlatf}`);
        detailPushPage({
          type: 1,
          url: `fund://page/fbproduct?fundcode=${this.fundCode}`,
        });
        return;
      }
      // #endif
      userLogin().then(() => {
        this.getUserAndshowCommentView(item);
      }).catch(() => {

      });
      this.reportMonitor({
        eventName: 'pz.jjtl.lz.plun',
        infoCodeType: '5',
        infoCode: this.fundCode,
        postid: item.PostId,
        eventContent: {
          postid: item.PostId,
        },
      });
    },
    async getUserAndshowCommentView(item) {
      const info = await this.$getUserInfo();
      const {
        uid,
      } = info;
      let isIOS = false;
      // #if EXECUTION_ENV === 'fund'
      // eslint-disable-next-line no-undef
      const systemInfo = fund.getSystemInfoSync();
      console.log(JSON.stringify(systemInfo));
      if (systemInfo) {
        if (systemInfo.system) {
          if (systemInfo.system.indexOf) {
            if (systemInfo.system.indexOf('iOS') !== -1) {
              isIOS = true;
            }
          }
        }
      }
      // #endif
      showCommentView({
        commentId: isIOS ? item.PostId : '',
        newsId: item.PostId,
        userId: uid,
        userName: '',
        repUserName: '',
        repUserId: '',
        content: '',
        t_type: 0,
        canNotTransmit: false,
      }).then(() => {
      }).catch(() => {
      });
    },
    getholdtip(item) {
      if (!item.PostUserInfo) {
        return '';
      }
      const userV = item.PostUserInfo.UserV; // 0-不加V，1-机构加V，2-个人加V
      const mgrId = item.PostUserInfo.MgrId;
      if (userV === 1) {
        // 只有普通用户和非基金经理的个人大v展示持有信息
        return '';
      }
      if (mgrId && mgrId.length > 0) {
        // 只有普通用户和非基金经理的个人大v展示持有信息
        return '';
      }
      const holdProfitType = item.FundProfitState;
      const fundHoldState = item.FundHoldStateNew;
      let profitType = 0;
      if (fundHoldState >= 0) {
        //
        profitType = holdProfitType === 0 ? -1 : 1;
      }
      // 从未持有
      if (profitType === 0) {
        return '';
      }
      let str = '';
      if (fundHoldState > 12) {
        str = '长期持有';
      } else if (fundHoldState > 2) {
        str = '中期持有';
      } else if (fundHoldState > 0) {
        str = '短期持有';
      } else if (fundHoldState === 0) {
        str = '历史持有';
      }
      return str;
    },
    getaddholdclass(item) {
      const holdProfitType = item.FundProfitState;
      const fundHoldState = item.FundHoldStateNew;
      let profitType = 0;
      if (fundHoldState > 0) {
        //
        profitType = holdProfitType === 0 ? -1 : 1;
      }
      if (profitType > 0) {
        return 'holdred';
      }
      if (profitType < 0) {
        return 'holdgreen';
      }
      return 'holdgray';
    },
    holdTip(item) {
      const holdProfitType = item.FundProfitState;
      const fundHoldState = item.FundHoldStateNew;
      let profitType = 0;
      if (fundHoldState > 0) {
        //
        profitType = holdProfitType === 0 ? -1 : 1;
      }
      if (profitType > 0) {
        this.$feedback.showToast({ title: '持有此基金收益为正', duration: 3000 });
        return;
      }
      if (profitType < 0) {
        this.$feedback.showToast({ title: '持有此基金收益为负', duration: 3000 });
        return;
      }
      this.$feedback.showToast({ title: '曾持有此基金', duration: 3000 });
    },
    clickMore() {
      window.sendTrackLog('Div', 'Click', 'xpzy.pzy.gdtl.click', '');
      detailPushPage({
        type: 1,
        url: `fund://page/fbproduct?fundcode=${this.fundCode}`,
      });
      // this.reportMonitor({
      //   eventName: 'pz.xx.qbtz',
      //   infoCodeType: '5',
      //   infoCode: this.fundCode,
      // });
    },
  },
};
</script>

<style scoped lang="less">
  .wrapper {
    background: #fff;
    border-radius: 12px;
  }
  .comTipBack{
    background-color: #ffffff;
    padding-top: 10px;
    padding-left: 24px;
    padding-right: 24px;
    display: flex;
    flex-direction: row;
    align-items: left;
    flex-wrap: wrap;
  }
  .com-tip-buttonall{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    border-radius: 28px;
    padding: 0px 24px;
    margin-top: 20px;
    margin-right: 20px;
    font-family: PingFangSC-Regular;
    font-size: 28px;
    color: #ff4400;
    background: #fff0eb;
  }
  .com-tip-button{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    border-radius: 28px;
    padding: 0px 24px;
    margin-top: 20px;
    margin-right: 20px;
    font-family: PingFangSC-Regular;
    font-size: 28px;
    color: #333333;
    background: #f5f5f5;
  }
  .comment{
    display: flex;
    flex-direction: row;
    margin-left: 32px;
    padding-right: 32px;
    padding-bottom: 30px;
    padding-top: 30px;
    &:nth-last-child(1) {
      &:after{
        display: none;
      }
    }
  }

  .header-img{
    width: 60px;
    height: 60px;
    border-radius: 60px;
    margin-right: 20px;
  }

  .comment-content{
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 0;
  }

  .user-name{
    font-family: PingFangSC-Regular;
    font-size: 30px;
    color: #4C618F;
  }

  .comment-text{
    font-family: PingFangSC-Regular;
    font-size: 32px;
    color: #000000;
    margin: 10px 0 20px 0;
  }

  .comment-time{
    flex: 1;
    font-family: PingFangSC-Regular;
    font-size: 26px;
    line-height: 40px;
    color: #999999;
  }

  .post-title {
    display: block; /* Fallback for non-webkit */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
    font-weight: bold;
    font-size: 32px;
    line-height: 46px;
    margin-bottom: 10px;
  }

  .image-wrapper{
    position: relative;
  }

  .userV {
    width: 30px;
    height: 30px;
    position: absolute;
    right: 10px;
    top: 40px;
  }
  .comment-v{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex: 1;
  }

.comment-option{
  flex: 1;
  display: flex;
  justify-content:flex-end;
  align-items: center;
}
.option-icon {
  z-index: 99;
    margin-left: 30px;
    width: 40px;
    height: 40px;
  }
.comment-image{
  width: 200px;
  margin-top: 20px;
  margin-right: 30px;
}
.name-view{
  display: flex;
  flex-direction: row;
  justify-content:flex-start;
  align-items: center;
}
.hold-tag {
  display: flex;
  border-radius: 4px;
  font-family: PingFangSC-Regular;
  font-size: 24px;
  letter-spacing: 0;
  padding-left:8px;
  padding-right:8px;
  height: 32px;
  align-items: center;
  justify-content: center;
  color: #ee7f7f;
  margin-left: 20px;
  background-color: rgba(238, 127, 127, 0.1);
}
.holdred{
  color: #ee7f7f;
  background-color: rgba(238, 127, 127, 0.1);
}
.holdgray{
  color: #9badc2;
  background-color: rgba(155, 173, 194, 0.1);
}
.holdgreen{
  color: #47b151;
  background-color: rgba(71, 177, 81, 0.1);
}
.empwrapper {
    background-color: #ffffff;
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.emptext {
    font-family: PingFangSC-Regular;
    font-size: 30px;
    color: #999999;
    text-align: center;
}
</style>
